<app-header (changedOppList)= "changedOppList($event)"></app-header>
<div class="loader-container" *ngIf="(isLoading | async)=== true">
    <img src="assets/images/loading.gif" alt="">
    <div>Loading Application </div>
</div>
<router-outlet *ngIf="(isLoading | async)=== false"></router-outlet>  